import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/programming-cloud.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M160 40a88.09 88.09 0 0 0-78.71 48.67A64 64 0 1 0 72 216h88a88 88 0 0 0 0-176m0 160H72a48 48 0 0 1 0-96c1.1 0 2.2 0 3.29.11A88 88 0 0 0 72 128a8 8 0 0 0 16 0 72 72 0 1 1 72 72" }, null, -1)])]);
}
var programming_cloud_default = { render };
//#endregion
export { programming_cloud_default as default, render };

//# sourceMappingURL=programming-cloud.svg.js.map